import styles from './FixcenterOrderingTable.module.scss';
import { useTranslation } from '../../i18n/useTranslation';
import { default as globalStyles } from '../../global-styles.module.scss';
import classNames from 'classnames';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { shopingCartAlertMaxWidth } from '../shopping-cart/services/shopping-cart.service';
import { SHOPPING_CART_PATHS } from '../../shared/constants/breadcrumb.constants';
import { useEffect, useRef } from 'react';

interface IShopingCartAlertProp {
    isOpen: boolean;
    handleCloseDialog: Function;
}

const ShopingCartAlert: React.FC<IShopingCartAlertProp> = ({ isOpen, handleCloseDialog }) => {
    const { t } = useTranslation('translation');
    const navigate = useNavigate();
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                handleCloseDialog();
            }
        }
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, handleCloseDialog]);

    if (!isOpen) {
        return null;
    }

    return (
        <Dialog
            disableScrollLock
            classes={{
                root: styles.shopping_cart_alert_container,
            }}
            open={isOpen}
            hideBackdrop={true}
            fullScreen={false}
            PaperProps={{ style: { margin: 0, maxWidth: `${shopingCartAlertMaxWidth}px` } }}
        >
            <DialogContent ref={ref} tabIndex={-1}>
                <div className={globalStyles.space_between_item}>
                    <div className={classNames(styles.shopping_cart_alert_icon, globalStyles.float_left_item)}>
                        <ShoppingCartIcon style={{ fontSize: '30px' }} />
                    </div>
                    <section>
                        <label>{t('FIXCENTER_ORDERING.HEADER_1')}</label>
                        <button
                            id={'shopping-cart-alert-go-to-cart-btn'}
                            className={classNames(
                                globalStyles.default_button_style,
                                styles.shopping_cart_alert_btn,
                                globalStyles.mt_3
                            )}
                            onClick={() => {
                                navigate(SHOPPING_CART_PATHS[1].link);
                            }}
                        >
                            {t('GO_TO_CART')}
                        </button>
                    </section>
                </div>
            </DialogContent>
        </Dialog>
    );
};
export default ShopingCartAlert;
